export enum QuestionSetType {
    QUESTION_LIST = "QuestionList",
    MULTIPLE_CHOICE_GRID = "MultipleChoiceGrid",
    SINGLE_SELECT_DROPDOWN = "SingleSelectDropdown"
}


// WEBPACK FOOTER //
// ./src/app/shared/models/question-set-type.ts